import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Education = () => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.5 } }}
            className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
        >
            {/* Column 1 - Degree */}
            <div className="w-full lgl:w-1/2">
                <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
                    <p className="text-sm text-designColor tracking-[4px]">
                        Systems Engineering
                    </p>
                    <h2 className="text-3xl md:text-4xl font-bold">Education</h2>
                </div>

                <div className="mt-6 lgl:mt-14 w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
                    <ResumeCard
                        title="B.S. in Systems Engineering"
                        subTitle="Universidad de Caldas · 2015"
                        result="Colombia"
                        des="Bachelor’s degree with strong foundations in software engineering, systems analysis, algorithms, databases, and computer science principles. Emphasis on structured problem-solving, software design, and applied computing, which later evolved into a specialization in QA automation and test engineering."
                    />
                </div>
            </div>

            {/* Column 2 - Certifications & Accreditations */}
            <div className="w-full lgl:w-1/2">
                <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
                    <p className="text-sm text-designColor tracking-[4px]">
                        Certifications & Accreditations
                    </p>
                    <h2 className="text-3xl md:text-4xl font-bold">Credentials</h2>
                </div>

                <div className="mt-6 lgl:mt-14 w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
                    {/* 2025 */}
                    <ResumeCard
                        title="AWS Certified Cloud Practitioner"
                        subTitle="Amazon Web Services (AWS) · 2025"
                        result="Certified"
                        des="Validated knowledge of AWS cloud fundamentals, including core services, security, pricing models, and architectural concepts. Applied in CI/CD pipelines, cloud-based test environments, and scalable QA automation strategies."
                    />

                    {/* 2022 */}
                    <ResumeCard
                        title="Microsoft Azure Fundamentals (AZ-900)"
                        subTitle="Microsoft · 2022"
                        result="Certified"
                        des="Demonstrates understanding of cloud concepts, Azure services, workloads, security, and pricing. Relevant for validating QA processes in Azure DevOps pipelines and cloud-hosted testing environments."
                    />

                    {/* 2021 */}
                    <ResumeCard
                        title="AWS Technical Accreditation"
                        subTitle="Amazon Web Services (AWS) · 2021"
                        result="Accredited"
                        des="Technical accreditation focused on AWS core services, cloud architecture best practices, and technical value propositions, supporting informed decisions when testing and validating cloud-native systems."
                    />

                    <ResumeCard
                        title="AWS Business Professional Accreditation"
                        subTitle="Amazon Web Services (AWS) · 2021"
                        result="Accredited"
                        des="Business-oriented accreditation covering cloud economics, value delivery, and customer use cases, enabling alignment between quality strategy, business goals, and cloud adoption."
                    />

                    {/* 2017 */}
                    <ResumeCard
                        title="ISTQB Certified Tester – Foundation Level (CTFL)"
                        subTitle="ISTQB · 2017"
                        result="Certified"
                        des="Strong foundation in software testing principles, test design techniques, test management, and quality assurance processes. Serves as the theoretical base for advanced automation frameworks, BDD practices, and risk-based testing strategies."
                    />
                </div>
            </div>
        </motion.div>
    );
};

export default Education;
